import React, { useState, useEffect } from "react";
import { Card, Col, Row, Input } from "antd";
import { useNavigate, useLocation } from "react-router-dom";

const QuarterlyEarnings = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleCardClick = (message) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("question", message);
    navigate(`/?${searchParams.toString()}`);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  const items = [
    {
      title: "Meta",
      message: "Analyze latest Earning Call Summary of Meta",
      description: "Earning Call Summary of Meta",
    },
    {
      title: "Amazon",
      message: "Analyze latest Earning Call Summary of Amazon",
      description: "Earning Call Summary of Amazon",
    },
    {
      title: "Microsoft",
      message: "Analyze latest Earning Call Summary of Microsoft",
      description: "Earning Call Summary of Microsoft",
    },
    {
      title: "Apple",
      message: "Analyze latest Earning Call Summary of Apple",
      description: "Earning Call Summary of Apple",
    },
    {
      title: "Nvidia",
      message: "Analyze latest Earning Call Summary of Nvidia",
      description: "Earning Call Summary of Nvidia",
    },
    {
      title: "Tesla",
      message: "Analyze latest Earning Call Summary of Tesla",
      description: "Earning Call Summary of Tesla",
    },
  ];

  const filteredItems = items.filter((item) =>
    item.title.toLowerCase().includes(searchQuery)
  );

  const renderSection = (title, items) => (
    <div
      style={{
        margin: isMobile ? "20% 5% 15%" : "5% 5% 5%",
      }}
    >
      <h2>{title}</h2>
      <Input
        placeholder="Search for a company..."
        value={searchQuery}
        onChange={handleSearchChange}
        style={{ marginBottom: "20px", width: "100%" }}
      />
      <Row gutter={16} style={{ display: "flex", alignItems: "stretch" }}>
        {items.map((item, index) => (
          <Col
            key={index}
            xs={24}
            sm={12}
            md={8}
            lg={8}
            xl={8}
            style={{ display: "flex" }}
          >
            <Card
              title={item.title}
              bordered={false}
              style={{
                flex: 1,
                backgroundColor: "whitesmoke",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "transform 0.3s, box-shadow 0.3s",
              }}
              className="card-hover-effect"
              onClick={() => handleCardClick(item.message)}
            >
              {item.description}
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );

  return (
    <div
      style={{
        paddingTop: isMobile ? "5%" : "5%",
        paddingBottom: isMobile ? "5%" : "5%",
      }}
    >
      {renderSection(
        "Earning Call Summaries along with Transcript",
        filteredItems
      )}
    </div>
  );
};

export default QuarterlyEarnings;
